import { z } from "zod";

export default {
  params: z.object({
    siren: z.string().regex(/^\d{9}$/),
  }),
  response: z.object({
    people: z.array(
      z.object({
        nom: z.string().nullable().optional(),
        prenom: z.string().nullable().optional(),
        prenoms: z.string().nullable().optional(),
        qualite: z.string().nullable().optional(),
        beneficiaireEffectif: z.boolean(),
      }),
    ),
    currentUserPersonKey: z.string().nullable(),
  }),
};
